<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>日志管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">日志管理</span>
      </div>

      <!-- 搜索条 -->
      <div>
        <el-form :model="queryInfo" :inline="true" size="normal">
          <el-form-item label="部门：">
            <el-select style="width:110px" v-model="queryInfo.department" placeholder="全部" clearable @change="getList">
              <el-option label="招商部" value="招商部"></el-option>
              <el-option label="运营部" value="运营部"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模块：">
            <el-select style="width:120px" v-model="queryInfo.module" placeholder="全部" clearable @change="getList">
              <el-option v-for="(name, key) in moduleMap" :key="key" :label="name" :value="key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="动作：">
            <el-select style="width:120px" v-model="queryInfo.action" placeholder="全部" clearable @change="getList">
              <el-option v-for="(name, key) in actionMap" :key="key" :label="name" :value="key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作人：">
            <el-input clearable v-model="queryInfo.operatorName" placeholder="姓名" @clear="getList"></el-input>
          </el-form-item>
          <el-form-item label="对象：">
            <el-input clearable v-model="queryInfo.keyword" placeholder="项目名/客户名等" @clear="getList"></el-input>
          </el-form-item>
          <el-form-item label="日期：">
            <el-date-picker
              v-model="queryInfo.date"
              type="daterange"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="getList">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格区域 -->
      <el-table :data="list" style="margin-top:0px" @expand-change="handleExpand">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div v-if="scope.row.traceId" style="padding: 0 20px">
              <h4 style="margin: 5px 0 10px">本次操作连带影响（含主记录）</h4>
              <el-table :data="traceMap[scope.row.traceId] || []" border size="mini">
                <el-table-column label="主/连带" width="80">
                  <template slot-scope="s">
                    <el-tag v-if="s.row._id === scope.row.traceId" size="mini" effect="dark">主记录</el-tag>
                    <el-tag v-else size="mini" type="info" effect="plain">连带</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="模块" width="90">
                  <template slot-scope="s">{{ s.row.module | moduleFormat }}</template>
                </el-table-column>
                <el-table-column label="动作" width="110">
                  <template slot-scope="s">
                    <el-tag :type="actionTagType(s.row.action)" size="small">{{ s.row.action | actionFormat }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="targetName" label="对象" min-width="160"></el-table-column>
                <el-table-column prop="operatorName" label="操作人" width="90"></el-table-column>
                <el-table-column prop="remark" label="说明" min-width="220" show-overflow-tooltip></el-table-column>
                <el-table-column label="时间" width="150">
                  <template slot-scope="s">{{ s.row.createDate | timeFormat }}</template>
                </el-table-column>
              </el-table>
            </div>
            <div v-else style="padding: 0 20px; color: #999; font-size: 13px">
              该记录为历史数据（无操作单号），无连带明细。
            </div>
          </template>
        </el-table-column>
        <el-table-column label="时间" width="150">
          <template slot-scope="scope">{{ scope.row.createDate | timeFormat }}</template>
        </el-table-column>
        <el-table-column prop="department" label="部门" width="90"></el-table-column>
        <el-table-column label="模块" width="90">
          <template slot-scope="scope">{{ scope.row.module | moduleFormat }}</template>
        </el-table-column>
        <el-table-column label="动作" width="110">
          <template slot-scope="scope">
            <el-tag :type="actionTagType(scope.row.action)" size="small">{{ scope.row.action | actionFormat }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="targetName" label="对象" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="operatorName" label="操作人" width="100"></el-table-column>
        <el-table-column prop="remark" label="说明" min-width="260" show-overflow-tooltip></el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

  </div>
</template>

<script>
import { MODULE_NAME_MAP, ACTION_NAME_MAP, moduleText, actionText, actionTagType } from '../../utils/operationLogMap'

export default {
  data () {
    return {
      list: [],
      // traceId -> 同批日志（行展开懒加载缓存）
      traceMap: {},
      moduleMap: MODULE_NAME_MAP,
      actionMap: ACTION_NAME_MAP,
      queryInfo: {
        department: '',
        module: '',
        action: '',
        operatorName: '',
        keyword: '',
        date: '',
        pagenum: 1,
        pagesize: 10
      },
      total: 0
    }
  },
  filters: {
    moduleFormat: moduleText,
    actionFormat: actionText,
    timeFormat (val) {
      if (!val) return '-'
      const d = new Date(val)
      const p = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    }
  },
  created () {
    this.getList()
  },
  methods: {
    actionTagType,
    // 获取列表
    async getList () {
      const obj = {
        department: this.queryInfo.department,
        module: this.queryInfo.module,
        action: this.queryInfo.action,
        operatorName: this.queryInfo.operatorName,
        keyword: this.queryInfo.keyword,
        pagenum: this.queryInfo.pagenum,
        pagesize: this.queryInfo.pagesize
      }
      delete obj.date
      if (this.queryInfo.date) {
        obj.startDate = this.queryInfo.date[0]
        obj.endDate = this.queryInfo.date[1]
      }
      const { data: res } = await this.$http.get('operationlog/list', { params: obj })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.list = res.data.list
      this.total = res.data.total
    },
    // 行展开：懒加载同批日志（含主记录）
    async handleExpand (row) {
      if (!row.traceId || this.traceMap[row.traceId]) return
      const { data: res } = await this.$http.get(`operationlog/trace/${row.traceId}`)
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.$set(this.traceMap, row.traceId, res.data.list)
    },

    // 监听pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getList()
    },

    // 监听页码改变
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getList()
    }

  }
}
</script>

<style lang="less" scoped>

</style>
